import { AgreementComponent } from './agreement/agreement.component';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const allComponents = [
  AgreementComponent,
  AuthenticateComponent,
  ResetPasswordComponent,
  UnauthorizedComponent,
];
export const publicComponents = [];

export * from './agreement';
export * from './authenticate';
export * from './reset-password';
export * from './unauthorized';
